import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, ThemeProvider, makeStyles } from "@material-ui/core";
import theme from "../Login/LoginSreen.breakpoints";
import { users } from "../../utils/newApi";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import styles from "./OneUserInfoScreen.styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import UserInfoBox from "../../components/UserInfo/UserInfoBox";
import { userTypes, userTypesforBackend } from "../../constants/usersConstants";

import { SERVER_ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const OneUserInfoScreen = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [user, setUser] = useState("");
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    users.usersInfo
      .one(id)
      .then((res) => {
        switch (res.data.type) {
          case userTypesforBackend[0]:
            res.data.type = userTypes[0];
            break;
          case userTypesforBackend[1]:
            res.data.type = userTypes[1];
            break;
        }
        setUser(res.data);
      })
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_FIND_USER);
      });
    setIsLoaded(true);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid
          container
          justifyContent="center"
          direction="row"
          alignItems="center"
        >
          <Grid item xs={12}>
            <UserInfoBox info={user} handleError={handleError} />
          </Grid>
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}

      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default OneUserInfoScreen;
